/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransferPackage } from './TransferPackage';
import {
    TransferPackageFromJSON,
    TransferPackageFromJSONTyped,
    TransferPackageToJSON,
} from './TransferPackage';

/**
 * 
 * @export
 * @interface ListTransferPackagesResponseBody
 */
export interface ListTransferPackagesResponseBody {
    /**
     * 
     * @type {Array<TransferPackage>}
     * @memberof ListTransferPackagesResponseBody
     */
    items: Array<TransferPackage>;
    /**
     * A cursor for use in the subsequent call.
     * @type {string}
     * @memberof ListTransferPackagesResponseBody
     */
    startingAfter?: string;
    /**
     * The total number of items in the collection.
     * @type {number}
     * @memberof ListTransferPackagesResponseBody
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ListTransferPackagesResponseBody interface.
 */
export function instanceOfListTransferPackagesResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function ListTransferPackagesResponseBodyFromJSON(json: any): ListTransferPackagesResponseBody {
    return ListTransferPackagesResponseBodyFromJSONTyped(json, false);
}

export function ListTransferPackagesResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTransferPackagesResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(TransferPackageFromJSON)),
        'startingAfter': !exists(json, 'starting_after') ? undefined : json['starting_after'],
        'totalCount': json['total_count'],
    };
}

export function ListTransferPackagesResponseBodyToJSON(value?: ListTransferPackagesResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(TransferPackageToJSON)),
        'starting_after': value.startingAfter,
        'total_count': value.totalCount,
    };
}

